// Libraries
import { ReactElement } from 'react';

// Components
import { CardProps } from '../../atoms/Card/Card';

// Styles
import styles from './CardGrid.module.css';

/**
 * @function CardGrid
 * Provides container for list of cards
 *
 * @example
 * return (
 *   <CardGrid perRow={3}></CardGrid>
 * )
 */
function CardGrid({ perRow, children }: CardGridProps): JSX.Element {
    return (
        <section className={styles.container}>
            <div className={styles.grid}>
                {children?.map((child) => {
                    // const sizeClass = `per-row-${perRow}`;
                    // const className = `${styles.item} ${styles[sizeClass]}`;
                    const className = `${styles.item}`;
                    return (
                        <div key={child.key} className={className}>
                            {child}
                        </div>
                    );
                })}
            </div>
        </section>
    );
}

/**
 * @interface CardGridProps
 * Describes the properties required for the CardGrid component
 *
 * @property {array} perRow Number of cards per row in grid
 * @property {ReactElement} children List of cards
 */
export interface CardGridProps {
    perRow: number;
    children?: ReactElement<CardProps>[];
}

// Exports
export default CardGrid;
